import React from 'react';
import { dailyCoachFailureMessage, dailyCoachRetryable } from './dailyCoachFailure';

export default function DailyCoachFailureNotice({ status, inChat = false, onOpenChat, onRetry, retrying = false, retryError = null, retryUncertain = false }) {
  if (!status) return null;
  const message = retryUncertain ? 'Could not confirm the daily insight retry. You can safely resend the same retry for this saved check-in.' : dailyCoachFailureMessage(status);
  const retryable = Boolean(onRetry) && (retryUncertain || dailyCoachRetryable(status));
  const retryButton = retryable ? (
    <button type="button" className="daily-coach-retry" onClick={onRetry} disabled={retrying}>
      {retrying ? 'Retrying…' : retryUncertain ? 'Resend daily insight retry' : 'Retry daily insight'}
    </button>
  ) : null;
  if (inChat) return (
    <div className="coach-hub-daily-failure" role="alert" data-testid="coach-daily-failure-in-chat">
      <strong>{retryUncertain ? 'Daily insight retry unconfirmed' : status.external_daily_task?.failure_code === 'DAILY_SNAPSHOT_CHANGED' ? 'Daily insight out of date' : 'Daily insight failed'}</strong>
      <span>{message}</span>
      {retryButton || <span>You can ask Coach about today here. This does not retry the failed insight.</span>}
      {retryError && !retryUncertain && <span role="alert">{retryError}</span>}
    </div>
  );
  return (
    <div className="dojo-toast coach-review-failed-toast daily-coach-failure-toast" role="alert">
      <div className="dojo-toast-accent" style={{ '--toast-accent': '#ef4444' }} />
      <div className="dojo-toast-body">
        <span className="dojo-toast-message">{message}</span>
        {retryError && !retryUncertain && <span className="daily-coach-retry-error" role="status">{retryError}</span>}
        {retryButton}
        <button type="button" className="daily-coach-failure-chat" onClick={onOpenChat}>View in Coach chat</button>
      </div>
    </div>
  );
}
